import * as z from 'zod';

export const InsectControlServiceSchema = z.object({
    tariffConfigId: z.number().int().positive(),
    description: z.string(),
    price: z.number(),
});

export type InsectControlService = z.infer<typeof InsectControlServiceSchema>;
